var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"foot"},[_c('div',{staticClass:"foot_txt"},[_vm._v("Copyright © 2019-2024 江苏追光智能科技有限公司")]),_c('div',{staticClass:"foot_txt"},[_vm._v("版权所有 Powered by EyouCms")]),_c('div',{staticClass:"foot_txt"},[_vm._v("备案号：苏ICP备20027758号-1")])])])
}]

export { render, staticRenderFns }